'use client';

import { Tooltip as MuiTooltip, TooltipProps } from '@mui/material';

import type { CSSProperties, ReactNode } from 'react';

type AppTooltipProps = {
  title: ReactNode;
  children: ReactNode;
  placement?: TooltipProps['placement'];
  enterDelay?: number;
  disableInteractive?: boolean;
  wrapperStyle?: CSSProperties;
  // * Extendable for future overrides.
} & Omit<TooltipProps, 'title' | 'children'>;

export function Tooltip({
  title,
  children,
  placement = 'top',
  enterDelay = 200,
  disableInteractive = true,
  wrapperStyle,
  ...rest
}: AppTooltipProps) {
  return (
    <MuiTooltip
      title={title}
      placement={placement}
      enterDelay={enterDelay}
      disableInteractive={disableInteractive}
      arrow
      slotProps={{
        tooltip: {
          sx: {
            fontSize: '0.953rem',
            backgroundColor: 'var(--nn-color-primary-accent-light)',
            color: 'var(--nn-white)',
            '& .MuiTooltip-arrow': {
              color: 'var(--nn-color-primary-accent-light)',
            },
          },
        },
      }}
      {...rest}
    >
      {/* // * Must wrap children. */}
      <span
        style={{
          display: 'inline-flex',
          width: 'fit-content',
          ...wrapperStyle,
        }}
      >
        {children}
      </span>
    </MuiTooltip>
  );
}
